/* global $ */

export class VideoControl {
	constructor(anchor) {
		this.$link = $(anchor)
		this.$overlay = null
		this.$body = $('body')

		this.$link.on('click', (e) => {
			e.preventDefault()
			this.showOverlay(this.$link.attr('href'))
		})
	}

	showOverlay(href) {
		// create overlay if it doesn't exist
		this.$overlay = $('#video-overlay')
		if (!this.$overlay.length) this.insertVideoOverlay()

		if (!this.$overlay.hasClass('show')) {
			// const iframe = '<iframe frameborder="0" src="' + href + '"></iframe>'
			const iframe = '<iframe frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen src="' + href + '?autoplay=1&modestbranding=1&rel=0"></iframe>'

			this.$overlay.find('.player').html(iframe)

			this.updateOverlay()

			this.$overlay.addClass('show')

			// disable body scroll
			this.$body.addClass('no-scroll')
		}
	}

	insertVideoOverlay() {
		// insert element
		$('main').append($('<div id="video-overlay" class="overlay"><div class="player"></div><div class="close"><span>Close</span></div></div>'))

		this.$overlay = $('#video-overlay')

		// close button
		this.$body.on('click', '#video-overlay .close', (e) => {
			e.preventDefault()
			this.hideOverlay()
		})

		// esc button
		$(window).on('keyup', (e) => {
			if (e.keyCode === 27) {
				this.hideOverlay()
			}
		})

		$(window).on('resize', () => {
			this.updateOverlay()
		})
	}

	updateOverlay() {
		const $iframe = $('#video-overlay .player iframe')

		if ($iframe.length) {
			var ratio = 9 / 16
			var ww = $(window).outerWidth()
			var wh = $(window).outerHeight()
			var horizontal = wh / ww < ratio

			if (horizontal) {
				$iframe.css({
					width: 100 / ratio + 'vh',
					height: '100vh',
				})
			} else {
				$iframe.css({
					width: '100vw',
					height: 100 * ratio + 'vw',
				})
			}
		}
	}

	hideOverlay() {
		// check for orientation change
		const event = new CustomEvent('check-orientation-refresh', {
			bubbles: true,
			detail: { forced: true }
		})
		document.dispatchEvent(event)

		if (this.$overlay && this.$overlay.hasClass('show')) {
			// stop video
			this.$overlay.find('.player').html('')

			this.$overlay.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', () => {
				this.$overlay.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend')
				this.$overlay.removeClass('show hide')
			})

			this.$overlay.addClass('hide')

			// enable body scroll
			this.$body.removeClass('no-scroll')
		}
	}
}
